<template>
  <div
    id="yqshow"
    class="section box_introduce animate__animated together init--zzQhF"
  >
    <div class="box_introduce_center maxWidth">
      <div class="box_introduce-main">
        <div class="box_introduce-main-title size_center">
          <div>原生引擎介绍</div>
          <div></div>
        </div>
        <div class="box_info">
          <div
            class="box_info-li"
            v-for="(item, index) in slideGather"
            :key="index"
          >
            <div :class="`box_info-li_${index + 1}`"></div>
            <div class="size_center">{{ item.title }}</div>
            <div>{{ item.content }}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
        slideGather: [
						{
							title: "正版授权 三端互通",
							content: "亚拓士中国大陆地区独家千年IP代理资质，原生引擎支持,IOS、Android、PC、H5、3D多平台，高效，稳定，完美实现多端互通"
						},
						{
							title: "可视化开发 自由定制",
							content: "独家原生开发引擎，共享资源库，自由编辑游戏GUI界面，各项游戏参数，自由配置定义游戏玩法，任务，活动，地图，怪物，人物等游戏内容，轻松打造专属千年版本"
						},
						{
							title: "接入网易易盾反外挂，破解加固系统",
							content: "智能外挂排查,拦截，在网络层，应用层，系统层提供全面防护，让游戏运行之路一帆风顺"
						},
						{
							title: "完美兼容其他千年引擎，一键转换",
							content: "原生引擎兼容市面绝大部分千年引擎，一键实现数据，资源转化，助力千年开发者，运营者快速开发"
						},
						{
							title: "引擎自带多套完成度100%千年游戏底板",
							content: "助力开发者快速实现版本商业化"
						},
						{
							title: "千年盒子流量支持",
							content: "合作伙伴可免费入驻千年游戏盒子，首发第一周可获得推荐资源位扶持"
						},
						{
							title: "完善的运营和运维工具",
							content: "我们为开发者提供完善的GM后台，数据综合后台，万能后台，BI后台，让开发者实时掌控产品信息，用户信息，区服生态信息。"
						},
						{
							title: "7*24小时对接团队保驾护航",
							content: "专业的 技术，运营，客服，市场团队全程对接支持，让您成功之路事半功倍"
						},
						{}
					],
    };
  },
  created() {},
  mounted() {},
  methods: {},
};
</script>

<style scoped lang="scss">

.box_introduce {
	position: relative;
	height: 16.4875rem/* 1319/80 */;
	background: #fafbf6;
}
.box_introduce_center{
	background: url("../../assets/images/pc/2.jpg") no-repeat center;
	background-size: cover;
	height: 100%;
}

.box_introduce-main-title>div:nth-child(1) {
	font-size: .45rem
		/* 36/80 */
	;
	color: #000000;
	padding-top: .775rem
		/* 62/80 */
	;
	margin-bottom: .3125rem
		/* 25/80 */
	;
	font-weight: 700;
}


.box_introduce-main-title div:nth-child(2) {
	width: 10.875rem
		/* 870/80 */
	;
	height: 1px;
	margin: 0 auto;
	background: linear-gradient(to right, #f9f8f5, #cac9c9 50%, #f9f8f5);
}

.box_introduce-main .box_info {
  margin: 0 auto;
  margin-top: 1.3875rem /* 111/80 */;
  width: 15.275rem /* 1222/80 */;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
}

.box_introduce-main .box_info > div {
  /* margin-right: 142px; */
  margin-bottom: 0.225rem /* 18/80 */;
  width: 4.275rem /* 342/80 */;
}
.box_introduce-main .box_info .box_info-li .box_info-li_1 {
  width: 0.875rem /* 70/80 */ !important;
  height: 0.875rem /* 70/80 */ !important;
  margin: 0 auto;
  background: url("../../assets/images/pc/box_info-1.png") no-repeat center;
  background-size: cover;
  background-image: 1rem /* 80/80 */ 1rem /* 80/80 */;
}

.box_introduce-main .box_info .box_info-li div:nth-child(2) {
  padding-top: 0.2125rem /* 17/80 */;
  padding-bottom: 0.225rem /* 18/80 */;
  color: #333333;
  font-size: 0.2375rem /* 19/80 */;
  font-weight: bold;
}

.box_introduce-main .box_info .box_info-li div:nth-child(3) {
  height: 1.8625rem /* 149/80 */;
  font-size: 0.175rem /* 14/80 */;
  line-height: 0.375rem /* 30/80 */;
  color: #666666;
}

.box_introduce-main .box_info .box_info-li > div:nth-child(1) {
  width: 0.95rem /* 76/80 */;
  height: 0.95rem /* 76/80 */;
  margin: 0 auto;
}

.box_introduce-main .box_info .box_info-li .box_info-li_2 {
  width: 0.875rem /* 70/80 */ !important;
  height: 0.875rem /* 70/80 */ !important;
  background: url("../../assets/images/pc/box_info-2.png") no-repeat center;
  background-size: cover;
}

.box_introduce-main .box_info .box_info-li .box_info-li_3 {
  width: 0.875rem /* 70/80 */ !important;
  height: 0.875rem /* 70/80 */ !important;
  background: url("../../assets/images/pc/box_info-3.png") no-repeat center;
  background-size: cover;
}

.box_introduce-main .box_info .box_info-li .box_info-li_4 {
  background: url("../../assets/images/pc/box_info-4.png") no-repeat center;
  background-size: cover;
}

.box_introduce-main .box_info .box_info-li .box_info-li_5 {
  background: url("../../assets/images/pc/box_info-5.png") no-repeat center;
  background-size: cover;
}

.box_introduce-main .box_info .box_info-li .box_info-li_6 {
  background: url("../../assets/images/pc/box_info-6.png") no-repeat center;
  background-size: cover;
}

.box_introduce-main .box_info .box_info-li .box_info-li_7 {
  background: url("../../assets/images/pc/box_info-7.png") no-repeat center;
  background-size: cover;
}

.box_introduce-main .box_info .box_info-li .box_info-li_8 {
  background: url("../../assets/images/pc/box_info-8.png") no-repeat center;
  background-size: cover;
}
</style>
